import { create } from 'zustand';

import { resetUsersPage } from './use-users-pagination-store';

export type UseEditUserStore = {
  userId: string;
};

const defaultValue: UseEditUserStore = {
  userId: '',
};

export const useEditUserStore = create<UseEditUserStore>(() => ({
  ...defaultValue,
}));

export const useEditUserId = () => useEditUserStore((state) => state.userId);

export const useEditUser = () => useEditUserStore((state) => state);

export const setUserIdFilter = (userId: UseEditUserStore['userId']) => {
  useEditUserStore.setState({ userId });
};

export const resetEditUserStore = () => {
  useEditUserStore.setState({ ...defaultValue });
  resetUsersPage();
};
